module.exports = "<div class=\"modal-header\">\n  <h2>{{ \"services.activations.buttons.activate.modal.title\" | translate}}</h2>\n</div>\n<p> </p>\n<p ng-if=\"attempt === 'enable'\">{{ \"services.activations.buttons.activate.modal.description\" | translate}}</p>\n<p ng-if=\"attempt !== 'enable'\">{{ \"services.deactivations.buttons.activate.modal.description\" | translate}}</p>\n<footer>\n  <button class=\"button\" ng-click=\"okFunc()\"> {{ \"services.activations.buttons.activate.modal.button\" | translate}} </button>\n</footer>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/services/activations/activations.modal.html
 ** module id = 493
 ** module chunks = 0
 **/